import { TitleCasePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoginService } from 'src/app/core/services/login.service';
import { OtpVerifyService } from 'src/app/core/services/otp-verify.service';
import { RoleSignupService } from 'src/app/core/services/role-signup.service';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-role-selection',
  templateUrl: './role-selection.component.html',
  styleUrls: ['./role-selection.component.scss'],
})
export class RoleSelectionComponent implements OnInit {
  // CustLogintoggle: boolean;

  loginForm: FormGroup;
  role: string = "Retailer";
  roles: string[] = ['Retailer', 'Shop', 'Warehouse', 'Customer', 'Employee'];
  showLoginForm: boolean = true;
  showEmployeeForm: boolean = false;
  submitted = false;

  public CustLogintoggle: boolean;


  constructor(private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private loginService: LoginService,
    public otpVerify: OtpVerifyService,
    private http: HttpClient,
    private route: ActivatedRoute,
    public roleSignupService: RoleSignupService,
    private spinner: NgxSpinnerService,
    private titleCasePipe: TitleCasePipe,) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [false]
    });

    const credentials = this.authService.retrieveRememberedCredentials();
    console.log("credential rericvedddd", credentials)
    if (credentials) {
      if (credentials.userType == "CLIENT") {
        this.onRoleChange('Retailer')
      } else if (credentials.userType == "CUSTOMER") {
        this.onRoleChange('Customer')
      } else if (credentials.userType == "EMPLOYEE") {
        this.onRoleChange('Employee')
      } else if (credentials.userType === 'WAREHOUSE') {
        this.onRoleChange('Retailer')
      } else if (credentials.userType === 'SHOP') {
        this.onRoleChange('Retailer')
      }



    }




  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.CustLogintoggle = params.get('CustLogintoggle') === 'true';
    });
  }

  // handleCustLogintoggleChange(value: boolean) {
  //   this.CustLogintoggle = value;
  //   console.log('CustLogintoggle in RoleSelectionComponent:', this.CustLogintoggle);
  // }

  get f() {
    return this.loginForm.controls;
  }

  onRoleChange(role: string) {
    this.role = role;
    this.showLoginForm = false;
    this.showEmployeeForm = false;

    switch (role) {
      case 'Retailer':
        this.showLoginForm = true;
        // this.onRetailerClick();
        break;
      case 'Shop':
        this.showLoginForm = true;
        // this.onRetailerClick();
        break;
      case 'Warehouse':
        this.showLoginForm = true;
        // this.onRetailerClick();
        break;
      case 'Customer':
        this.showLoginForm = false;
        // this.onCustomerClick();
        break;
      case 'Employee':
        this.showEmployeeForm = true;
        // this.onEmployeeClick();
        break;
      default:
        break;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.valid) {
      console.log(this.loginForm.value);
    }
  }

  togglePasswordVisibility() {
    const passwordField = document.getElementById('password');
    const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
    passwordField.setAttribute('type', type);
  }

  onCustomerRegisterClick() {
    this.router.navigate(['/auth/register'], { queryParams: { Custtoggle: 'true' } });
  }

  onRetailerRegisterClick() {
    this.router.navigate(['/auth/register'], { queryParams: { Custtoggle: 'false' } });
  }


  // onCustomerClick() {
  //   this.router.navigate(['/auth/login'], { queryParams: { CustLogintoggle: 'true' } });
  // }

  // onRetailerClick() {
  //   this.router.navigate(['/auth/login'], { queryParams: { CustLogintoggle: 'false' } });
  // }

  onEmployeeClick() {
    this.router.navigate(['/auth/login-employee'], {
      queryParams: { CustLogintoggle: 'false' },
    });
  }
}
